import { gql } from "@apollo/client";
import { get } from "lodash";

export const REQUEST_REFUND_METHODS = gql`
	mutation RefundMethods (
		$saleOrderId: Int
		$saleOrderLineItemIds: [ String! ]
	) {
		OrderRoute {
			id
			postRefundmethods (
				saleOrderId: $saleOrderId
				saleOrderLineItemIds: $saleOrderLineItemIds
			) {
				saleOrderId
				saleOrderRefundMethods {
					id
					refundPaymentType
					type
					refundAmount
					priority

					...on WSOriginalPaymentRefundMethod {
						authRefNbr
						payment {
							authRefNbr
							paymentType
							paymentSubtype
							paymentDateTime
							paymentAmount
							paymentReferenceNumber
							paymentAllocatedAmount
							paymentStatus
							refundableAmount
						}
					}

					...on WSSubsystemAccountValueRefundMethod {
						subsystem
						subsystemAccountReference
						purseRestriction
						purseType
					}
				}
				saleOrderLineItemRefundMethods {
					id
					saleOrderLineItemId
					isRefundRequired
					allowsRefund
					lineItemType
					lineItemTypeDescription
					itemName
					lineItemStatus
					lineItemStatusDescription
					itemTotalAmount
					itemRefundAmount
					refundFeeAmount
					refundMethods {
						id
						refundPaymentType
						type
						refundAmount
						priority

						...on WSOriginalPaymentRefundMethod {
							authRefNbr
							payment {
								authRefNbr
								paymentType
								paymentSubtype
								paymentDateTime
								paymentAmount
								paymentReferenceNumber
								paymentAllocatedAmount
								paymentStatus
								refundableAmount
							}
						}

						...on WSSubsystemAccountValueRefundMethod {
							subsystem
							subsystemAccountReference
							purseRestriction
							purseType
						}
					}
				}
			}
		}
	}`;


export const getRefundMethods = (response) => {
	return get(response, 'data.OrderRoute.postRefundmethods', []);
};
